// components/Skills.js
import React from 'react';
import styled from 'styled-components';
import { FaPython, FaJava, FaHtml5, FaReact, FaDatabase, FaCloud } from 'react-icons/fa';
import { SiJavascript, SiDjango, SiFastapi, SiApachehadoop, SiC, SiTensorflow, SiPytorch, SiSpringboot } from 'react-icons/si';
import { TbBrandCucumber } from "react-icons/tb";

const SkillsSection = styled.section`
  padding: 70px;
  color: #fff;
  max-width: 800px;
  margin: 20px auto 0 auto;
  font-family: "Garamond", serif;
  background-color: rgb(23, 29, 41);
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 50px 20px;
  }

  @media (max-width: 480px) {
    padding: 40px 12px;
  }
`;

const SkillsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: 30px;
`;

const SkillCard = styled.div`
  background-color: #2c3e50;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  width: 140px;
  transition: transform 0.3s;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 480px) {
    width: 40%;
    padding: 15px;
  }
`;

const SkillIcon = styled.div`
  font-size: 2.8em;
  margin-bottom: 10px;

  @media (max-width: 480px) {
    font-size: 2.2em;
  }
`;

const SkillName = styled.div`
  font-size: 1.1em;
  font-weight: bold;

  @media (max-width: 480px) {
    font-size: 1em;
  }
`;

const Skills = () => {
  return (
    <SkillsSection id="skills">
      <h1>Skills</h1>
      <SkillsContainer>
        <SkillCard><SkillIcon><FaPython /></SkillIcon><SkillName>Python</SkillName></SkillCard>
        <SkillCard><SkillIcon><FaJava /></SkillIcon><SkillName>Java</SkillName></SkillCard>
        <SkillCard><SkillIcon><SiC /></SkillIcon><SkillName>C</SkillName></SkillCard>
        <SkillCard><SkillIcon><FaHtml5 /></SkillIcon><SkillName>HTML/CSS</SkillName></SkillCard>
        <SkillCard><SkillIcon><FaReact /></SkillIcon><SkillName>React</SkillName></SkillCard>
        <SkillCard><SkillIcon><SiJavascript /></SkillIcon><SkillName>JavaScript</SkillName></SkillCard>
        <SkillCard><SkillIcon><SiSpringboot /></SkillIcon><SkillName>SpringBoot</SkillName></SkillCard>
        <SkillCard><SkillIcon><SiDjango /></SkillIcon><SkillName>Django</SkillName></SkillCard>
        <SkillCard><SkillIcon><SiFastapi /></SkillIcon><SkillName>FastAPI</SkillName></SkillCard>
        <SkillCard><SkillIcon><FaDatabase /></SkillIcon><SkillName>MySQL</SkillName></SkillCard>
        <SkillCard><SkillIcon><TbBrandCucumber /></SkillIcon><SkillName>Cucumber</SkillName></SkillCard>
        <SkillCard><SkillIcon><FaCloud /></SkillIcon><SkillName>AWS</SkillName></SkillCard>
        <SkillCard><SkillIcon><FaDatabase /></SkillIcon><SkillName>Cassandra</SkillName></SkillCard>
        <SkillCard><SkillIcon><SiApachehadoop /></SkillIcon><SkillName>Apache Hadoop</SkillName></SkillCard>
        <SkillCard><SkillIcon><SiTensorflow /></SkillIcon><SkillName>TensorFlow</SkillName></SkillCard>
        <SkillCard><SkillIcon><SiPytorch /></SkillIcon><SkillName>PyTorch</SkillName></SkillCard>
      </SkillsContainer>
    </SkillsSection>
  );
};

export default Skills;
